export default __webpack_public_path__ + "static/media/work-flow.f8a44fec.png";